import _classCallCheck from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * DevExtreme (esm/ui/form/ui.form.item_option_action.js)
 * Version: 21.1.12
 * Build date: Fri Apr 07 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import Class from "../../core/class";

var ItemOptionAction =
/*#__PURE__*/
function () {
  function ItemOptionAction(options) {
    _classCallCheck(this, ItemOptionAction);

    this._options = options;
    this._itemsRunTimeInfo = this._options.itemsRunTimeInfo;
  }

  _createClass(ItemOptionAction, [{
    key: "findInstance",
    value: function findInstance() {
      return this._itemsRunTimeInfo.findWidgetInstanceByItem(this._options.item);
    }
  }, {
    key: "findItemContainer",
    value: function findItemContainer() {
      return this._itemsRunTimeInfo.findItemContainerByItem(this._options.item);
    }
  }, {
    key: "tryExecute",
    value: function tryExecute() {
      Class.abstract();
    }
  }]);

  return ItemOptionAction;
}();

export { ItemOptionAction as default };